import { useEffect, useRef, useState } from "react";
import { Alert, Box, CircularProgress, Typography } from "@mui/material";
import { Link as RouterLink, useNavigate, useSearchParams } from "react-router-dom";

import apiClient from "../../api-client";
import { AuthLayout } from "../../components/AuthLayout";
import { Button } from "../../components/Button";
import { CustomTextField } from "../../components/CustomTextField";
import { useAuth } from "../../components/contexts/AuthContext";
import { FormField } from "../../components/FormField";

export function VerifyEmail() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { authenticateWithTokens } = useAuth();
  const [error, setError] = useState("");
  const [verifiedWithoutSession, setVerifiedWithoutSession] = useState(false);
  const [email, setEmail] = useState("");
  const [resent, setResent] = useState(false);
  const attempted = useRef(false);

  useEffect(() => {
    if (attempted.current) return;
    attempted.current = true;
    const token = params.get("token");
    if (!token) { setError("Falta el token de verificación."); return; }
    // La verificación devuelve tokens: entra directamente a la bienvenida
    apiClient.post("auth/verify-email/", { token })
      .then(({ data }) => authenticateWithTokens(data))
      .then((authenticated) => {
        // El email ya queda verificado aunque falle la carga del perfil: toca entrar por el login
        if (authenticated) navigate("/bienvenida", { replace: true });
        else setVerifiedWithoutSession(true);
      })
      .catch((requestError) => setError(requestError.response?.data?.token || "No se pudo verificar el correo."));
  }, [params, authenticateWithTokens, navigate]);

  const footer = <>¿Ya tienes acceso? <RouterLink to="/login">Inicia sesión</RouterLink></>;

  if (verifiedWithoutSession) return <AuthLayout kicker="Verificación" title="Email verificado" subtitle="Tu espacio y tu prueba gratuita ya están activos." footer={footer}>
    <Box sx={{ display: "grid", gap: 2 }}>
      <Alert severity="success">Tu cuenta se ha verificado correctamente.</Alert>
      <Typography variant="body2">No hemos podido iniciar tu sesión automáticamente. Entra con tu email y contraseña para continuar.</Typography>
      <Button size="lg" fullWidth onClick={() => navigate("/login", { replace: true })}>Iniciar sesión</Button>
    </Box>
  </AuthLayout>;

  return <AuthLayout kicker="Verificación" title="Verificando tu email" subtitle="Estamos activando tu espacio y tu prueba gratuita." footer={footer}>
    {error ? <Box sx={{ display: "grid", gap: 2 }}>
      <Alert severity="error">{error}</Alert>
      <FormField label="Email" htmlFor="verify-email">
        <CustomTextField id="verify-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="tu@agencia.com" />
      </FormField>
      <Button size="lg" fullWidth disabled={!email.includes("@") || resent} onClick={() => apiClient.post("auth/resend-verification/", { email }).then(() => setResent(true))}>{resent ? "Enlace enviado" : "Reenviar verificación"}</Button>
    </Box> :
      <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}><CircularProgress size={24} /><Typography>Un momento…</Typography></Box>}
  </AuthLayout>;
}
